import { render } from "./JobSeekerApplications.vue?vue&type=template&id=668dd712"
import script from "./JobSeekerApplications.vue?vue&type=script&lang=js"
export * from "./JobSeekerApplications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__